
export namespace   PerformUrl  {
    const prefix = 'syncprocess/'
    export const downSync: string = `${prefix}downloadvisitdata`;
    export const downloadVisitData = `${prefix}downloadvisitlist`;
    export const ATTACHMENT_UPLOAD = `${prefix}attachmentuploadurls`;
    export const CLOUD_UPLOAD_URL = 'https://stansfnewaudittest.blob.core.windows.net/audit-blob';
    export const UPLOAD_VISIT_DATA = 'syncprocess/uploadvisitdata';
    export const attDownloadUrl = 'syncprocess/attachmentdownloadurls';
    export const announcement = 'user/announcement';
}
